export default __webpack_public_path__ + "static/media/au_agcy.3549be92.jpg";